module.exports = "/assets/data/bfc896810e96efeceb54a92581f4cf83-DG12.data.json";